function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsdCrane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.63,228.04c-3.11-61.08-28.59-122-74.51-163.19C339.93,.08,199.3,1.47,125.2,62.39c-25.7,21.13-40.83,49.05-46.74,81.44-6.32,34.67,1.94,72.33-11.66,105.71-11.69,28.67-40.5,46.25-51.18,75.26-12.75,34.63-5.94,78.64,21.74,104.37,35.45,32.97,98.72,45.68,145.34,50.48,142.39,14.68,292.51-68.04,303.63-222.62,.69-9.65,.78-19.35,.29-29.01Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,228.04c-3.11-61.08-28.59-122-74.51-163.19C339.93,.08,199.3,1.47,125.2,62.39c-25.7,21.13-40.83,49.05-46.74,81.44-6.32,34.67,1.94,72.33-11.66,105.71-11.69,28.67-40.5,46.25-51.18,75.26-12.75,34.63-5.94,78.64,21.74,104.37,35.45,32.97,98.72,45.68,145.34,50.48,142.39,14.68,292.51-68.04,303.63-222.62,.69-9.65,.78-19.35,.29-29.01Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 462,
    y1: 468.34,
    x2: 494.18,
    y2: 468.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.97,
    y1: 468.34,
    x2: 454.76,
    y2: 468.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.13,
    y1: 468.34,
    x2: 58.14,
    y2: 468.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "401.66 266.42 401.66 188.38 412.92 188.38 412.92 180.33 446.71 180.33 446.71 186.77 455.56 186.77 455.56 320.32 479.7 320.32 479.7 343.65 494.98 343.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "292.25 276.87 292.25 216.54 315.58 216.54 315.58 231.02 326.84 231.02 326.84 210.1 351.78 210.1 351.78 300.2 372.7 300.2 372.7 332.38 389.59 332.38 389.59 282.51 401.66 282.51 401.66 272.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "204.56 236.65 204.56 343.65 218.23 343.65 218.23 280.9 237.54 280.9 237.54 333.99 292.25 333.99 292.25 286.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "161.92 315.49 161.92 183.55 204.56 183.55 204.56 227.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.06 276.87 79.06 292.16 91.12 292.16 91.12 222.97 139.39 222.97 139.39 329.97 161.92 329.97 161.92 319.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.76 343.65 44.46 343.65 44.46 243.89 79.06 243.89 79.06 268.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M457.17,120.8s-6.44-12.87-18.5-11.26c-12.07,1.61-13.68,13.68-16.89,14.48s-10.46-4.02-15.29-1.61c-4.83,2.41-8.04,8.04-8.04,8.04,0,0-6.44-2.41-11.26,0s-7.24,7.24-7.24,7.24h100.56s-.8-12.87-8.04-15.29c-7.24-2.41-12.07,4.83-15.29-1.61Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,167.04s-4.76-9.51-13.68-8.33c-8.92,1.19-10.11,10.11-12.49,10.7-2.38,.59-7.73-2.97-11.3-1.19-3.57,1.78-5.95,5.95-5.95,5.95,0,0-4.76-1.78-8.33,0-3.57,1.78-5.35,5.35-5.35,5.35h74.34s-.59-9.52-5.95-11.3c-5.35-1.78-8.92,3.57-11.3-1.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.92,132.78s-4.02-8.03-11.55-7.03c-7.53,1-8.54,8.54-10.55,9.04-2.01,.5-6.53-2.51-9.54-1-3.01,1.51-5.02,5.02-5.02,5.02,0,0-4.02-1.51-7.03,0-3.01,1.51-4.52,4.52-4.52,4.52h62.77s-.5-8.03-5.02-9.54c-4.52-1.51-7.53,3.01-9.54-1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-118"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "320.8 87.41 256.99 38.31 368.58 87.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 100.1,
    y1: 324.35,
    x2: 100.1,
    y2: 113.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.11,
    y1: 324.35,
    x2: 114.11,
    y2: 113.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.48,
    y: 90.36,
    width: 36.42,
    height: 17.99,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.26 118.88 92.12 118.88 88.48 108.35 124.9 108.35 121.26 118.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.76 74.3 256.99 38.31 177.15 74.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "246.15 89.62 263.72 75.24 252.48 63.43 259.51 52.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.07 449.21 246.15 449.21 246.15 89.62 256.99 38.31 268.07 89.62 268.07 449.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 149.26 246.3 171.03 266.51 171.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 129.38 246.3 151.15 266.51 151.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 109.5 246.3 131.26 266.51 131.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 89.62 246.3 111.38 266.51 111.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 172.64 246.3 194.4 266.51 194.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 196.02 246.3 217.78 266.51 217.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 219.4 246.3 241.16 266.51 241.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 242.78 246.3 264.54 266.51 264.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 266.16 246.3 287.92 266.51 287.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 289.54 246.3 311.3 266.51 311.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 312.91 246.3 334.68 266.51 334.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 336.29 246.3 358.06 266.51 358.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 359.67 246.3 381.43 266.51 381.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 383.05 246.3 404.81 266.51 404.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "268.07 406.43 246.3 428.19 266.51 428.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 218.42,
    y: 445.56,
    width: 77.31,
    height: 12.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.66,
    y: 455.91,
    width: 130.83,
    height: 12.44,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 125.82,
    width: 27.61,
    height: 24.06,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238.56,
    y: 160.04,
    width: 37.1,
    height: 9.84,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.79 160.05 238.43 160.05 243.3 150.21 270.91 150.21 275.79 160.05",
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,126.22h-29.28v-27.12h31.24c1.74,0,3.11,1.5,2.95,3.23l-1.96,21.21c-.14,1.52-1.42,2.69-2.95,2.69Z",
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,104.95v15.75c0,.61,.46,1.13,1.07,1.2l10.42,1.13c2.77,.3,5.18-1.87,5.18-4.65v-13.42c0-.66-.54-1.2-1.2-1.2h-14.27c-.66,0-1.2,.54-1.2,1.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "330.09 91.16 36.03 91.16 48.4 75.42 230.01 75.42 237.88 89.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "48.4 75.42 48.4 90.6 63.02 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.58 75.42 63.58 90.6 78.2 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.76 75.42 78.76 90.6 93.38 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.94 75.42 93.94 90.6 108.56 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "109.12 75.42 109.12 90.6 123.74 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "124.3 75.42 124.3 90.6 138.92 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.48 75.42 139.48 90.6 154.1 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.66 75.42 154.66 90.6 169.28 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "169.84 75.42 169.84 90.6 184.46 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "185.03 75.42 185.03 90.6 199.64 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.21 75.42 200.21 90.6 214.82 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.39 75.42 215.39 90.6 230.01 75.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256.99,
    cy: 38.31,
    r: 5.62,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.83,
    y: 87.81,
    width: 52.75,
    height: 6.4,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.01,
    y: 94.1,
    width: 34.4,
    height: 6.4,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.66,
    y: 100.51,
    width: 15.29,
    height: 19.2,
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "273.3 89.48 273.3 72.05 366.63 72.05 366.63 87.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.83,
    y1: 87.81,
    x2: 315.83,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.4,
    y1: 90.5,
    x2: 301.4,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.61,
    y1: 90.5,
    x2: 286.61,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.59,
    y1: 87.81,
    x2: 333.59,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.35,
    y1: 87.81,
    x2: 351.35,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.81,
    y1: 80.88,
    x2: 365.92,
    y2: 80.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.22,
    y: 87.64,
    width: 27.61,
    height: 13.86,
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "97.86 87.64 93.61 87.64 107.47 101.49 111.71 101.49 97.86 87.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.69 101.49 102.94 101.49 93.22 91.78 93.22 96.02 98.69 101.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.63 87.64 102.39 87.64 116.25 101.49 120.49 101.49 106.63 87.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.41 87.64 111.17 87.64 120.84 97.31 120.84 93.06 115.41 87.64",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.35,341.22v2.81c0,2.15-2.54,4.36-3.67,6.01-3.19,4.66-1.29,13.3,5.28,13.42,5.61,.1,6.95-5.25,6.29-9.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,332.63v8.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.49,
    y: 320.25,
    width: 19.07,
    height: 13.86,
    transform: "translate(434.21 220.15) rotate(90)",
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "113.96 320.84 113.96 317.91 100.1 327.48 100.1 330.41 113.96 320.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.1 321.42 100.1 324.35 109.81 317.64 105.57 317.64 100.1 321.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.96 326.91 113.96 323.98 100.1 333.55 100.1 336.48 113.96 326.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.96 332.97 113.96 330.04 104.29 336.72 108.53 336.72 113.96 332.97",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M106.69,125.03h0c-1.58,0-2.85-1.28-2.85-2.85v-4.61h5.7v4.61c0,1.58-1.28,2.85-2.85,2.85Z",
    style: {
      fill: "#D8571B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsdCrane);
export default __webpack_public_path__ + "static/media/psd-crane.42e6d45e89119661f78531ff4b3b13f9.svg";
export { ForwardRef as ReactComponent };